// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2QCrW","unreadBadge":"styles_unreadBadge__16jo8","modalContent":"styles_modalContent__uxCPP","modal":"styles_modal__xrV43"};